const _ = require('lodash');
const FILTER_TYPE = require('./filter-type-enum');
module.exports = function (FiltersService) {
	return {
		restrict: 'E',
		scope: {
			filter: '=filterData'
		},
		link(scope) {
			scope.filterService = FiltersService;
			scope.priceFilter = undefined;
			scope.priceRangeFilter = _.filter(scope.filterService.filters, { FilterType: FILTER_TYPE.RANGE })[0];
			scope.rangeFilter = {
				Min: null,
				Max: null
			};

			scope.initRangeFilter = function () {
				const range = _.filter(scope.filterService.appliedFilter, { Key: scope.priceRangeFilter.Name })[0];
				if (range) {
					scope.rangeFilter = {
						Min: parseInt(range.Items[0].Min),
						Max: parseInt(range.Items[0].Max)
					};
				}
			};

			scope.applyPriceFilter = function (filter) {
				if (scope.priceRangeFilter) {
					_.remove(scope.filterService.appliedFilter, (obj) => {
						return obj.Key === FILTER_TYPE.PRICE_RANGE;
					});
					scope.rangeFilter.Min = scope.rangeFilter.Max = null;
					scope.rangeForm.$setPristine();
				}
				scope.filterService.applyFilter(scope.priceFilter.Name, { Min: filter.Min.toString(), Max: filter.Max.toString() });
			};

			scope.filterByRange = function () {
				if (scope.rangeFilter.Min !== null && scope.rangeFilter.Max !== null && scope.rangeFilter.Max > scope.rangeFilter.Min) {
						_.remove(scope.filterService.appliedFilter, (obj) => {
							return obj.Key === FILTER_TYPE.PRICE_RANGE || obj.Key === FILTER_TYPE.PRICE;
						});

						scope.filterService.applyFilter(scope.priceRangeFilter.Name, {
							Min: scope.rangeFilter.Min,
							Max: scope.rangeFilter.Max
						});
				}
			};

			if (scope.priceRangeFilter) {
				scope.initRangeFilter();
			}

			scope.$watch('filter', (filter) => {
					scope.priceFilter = filter;
					_.remove(scope.priceFilter.Results, (obj) => {
							return obj.Count === 0;
					});
			});
		},
		template: require('./filter-price-template.html')
	};
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/advance-filter/filter-price-directive.js
 **/